<mat-card class="default-card grid-all">
    <mat-card-header>
        <mat-card-title>{{ title }}</mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <div class="container">
            @if (data.mode !== FormMode.Creation) {
                <div class="form-item">
                    <mat-form-field class="mat-form-field-name">
                        <mat-label>Id</mat-label>
                        <input matInput [formControl]="idFormControl" [(ngModel)]="data.record.id" autocomplete="off" readonly />
                    </mat-form-field>
                </div>
            }
            <div class="form-item">
                <mat-form-field class="mat-form-field-action-type">
                    <mat-label>Attribut</mat-label>
                    <mat-select [formControl]="attributeFormControl" [(ngModel)]="data.record.attributeId" required>
                        @for (attribute of attributes; track attribute) {
                            <mat-option [value]="attribute.id">{{ attribute.header }}</mat-option>
                        }
                    </mat-select>
                    @if (attributeFormControl?.errors?.required && (attributeFormControl?.dirty || attributeFormControl.touched)) {
                        <mat-error>Le champ 'Attribut' est obligatoire.</mat-error>
                    }
                </mat-form-field>
            </div>
            <div class="form-item">
                <mat-form-field class="mat-form-field-name">
                    <mat-label>Taille</mat-label>
                    <input matInput [formControl]="sizeFormControl" [(ngModel)]="data.record.size" autocomplete="off" required />
                    @if (sizeFormControl?.errors?.required && (sizeFormControl?.dirty || sizeFormControl.touched)) {
                        <mat-error>Le champ 'Taille' est obligatoire.</mat-error>
                    }
                </mat-form-field>
            </div>
            <div class="form-item">
                <mat-checkbox class="accent-button" matInput [formControl]="stickyFormControl" [(ngModel)]="data.record.isStickyColumn">Colonne figée</mat-checkbox>
            </div>
        </div>
    </mat-card-content>
    <mat-card-actions>
        <button mat-stroked-button class="accent-button" [ngClass]="{ hidden: data.mode === FormMode.Reading }" (click)="cancel()">Annuler</button>
        @if (data.mode !== FormMode.Reading) {
            <button mat-raised-button class="accent-button" [mat-dialog-close]="data.record" [disabled]="!isValid">Enregistrer</button>
        } @else {
            <button mat-raised-button class="accent-button" (click)="cancel()">Ok</button>
        }
    </mat-card-actions>
</mat-card>
